import React from 'react'
import NavBarCandidate from '../components/NavBarCandidate'
import Form from '../components/EditCandidateProfile/Form'
import Footer from '../components/Footer'


function EditCandidateProfile() {
  return (
    <div>
        <NavBarCandidate />
        <Form />
        <Footer />
    </div>
  )
}

export default EditCandidateProfile